module.exports = __webpack_public_path__ + "img/sixpackcarrier07.ded1bac5.jpg";